import { ISolicitacao } from '@/@types/Protocolo/Solicitacoes';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { format } from 'date-fns';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Separator } from '@/components/ui/separator';
import { Loading } from '@/components/shared/Loading';
import { AlertMessage } from '@/components/shared/AlertMessage';

interface IDetalhesSolicitacaoComponentProps {
    data: ISolicitacao;
    isLoading: boolean;
}

/**
 * Componente responsável por exibir os detalhes de uma solicitação de serviço.
 * @param data Dados da solicitação a serem exibidos.
 * @param isLoading Indica se os dados estão sendo carregados.
 * @returns Componente de detalhes da solicitação de serviço.
 */

const DetalhesSolicitacaoComponent = ({ data, isLoading }: IDetalhesSolicitacaoComponentProps) => {

    return (

        <>
            {isLoading ? (
                <>
                    <Loading color='primary' />
                </>
            ) : (

                <>
                    {data._id ? (
                        <div className='mt-[16px] flex-col'>

                            <h4 className='text-center'>Protocolo de solicitação de serviços - {data.protocolo_numero}</h4 >

                            <Card className='mt-[16px]'>
                                <CardHeader className='bg-colorPrimary pt-[0.75rem] pb-[0.75rem] pl-[1.25rem] pr-[1.25rem] rounded-t-md'>
                                    <span className='font-semibold text-colorPrimary-foreground'>Solicitante:</span>
                                </CardHeader>

                                <CardContent className='mt-[20px]'>
                                    <div className='flex-col'>
                                        <div className='md:flex'>

                                            <div className='flex-1 mt-[15px]'>
                                                <strong>Data e Hora</strong>
                                                <p>
                                                    {data.protocolo_data && format(new Date(data.protocolo_data), 'dd/MM/yyyy')} - {data.protocolo_hora}
                                                </p>
                                            </div>

                                            <div className='flex-1 mt-[15px]'>
                                                <strong>Documento</strong>
                                                <p>{data.protocolo_documento}</p>
                                            </div>

                                            <div className='flex-1 mt-[15px]'>
                                                <strong>Solicitante</strong>
                                                <p>{data.protocolo_nome}</p>
                                            </div>

                                            <div className='flex-1 mt-[15px]'>
                                                <strong>Telefone</strong>
                                                <p>{data.protocolo_telefone}</p>
                                            </div>
                                        </div>

                                        <div className='md:flex md:mt-[40px]'>
                                            <div className='flex-1 mt-[15px]'>
                                                <strong>E-mail</strong>
                                                <p>{data.protocolo_email}</p>
                                            </div>
                                            <div className='flex-1 mt-[15px]'>
                                                <strong>Serviço Solicitado</strong>
                                                <p>{data.protocolo_servico}</p>
                                            </div>
                                            <div className='flex-1 mt-[15px] break-words'>
                                                <strong>Anexo</strong>
                                                <p>{data.protocolo_anexo ? <a target='_blank' href={data.protocolo_anexo}>{data.protocolo_anexo}</a> : 'Nenhum arquivo anexado'}</p>
                                            </div>
                                        </div>

                                    </div>
                                </CardContent>
                            </Card>

                            <div className='mt-[24px]'>
                                <h4 className='text-center'>Protocolo resposta</h4>
                                <Separator className='mt-[10px]' />

                                <Table className='w-full mt-[16px]'>
                                    <TableHeader>
                                        <TableHead>
                                            <i className='far fa-calendar-alt mr-[5px]'></i> Data
                                        </TableHead>

                                        <TableHead>
                                            <i className='fas fa-battery-three-quarters mr-[5px]'></i>
                                            Status
                                        </TableHead>

                                        <TableHead>
                                            <i className='far fa-file-alt mr-[5px]'></i>
                                            Descrição
                                        </TableHead>

                                        <TableHead>
                                            <i className='fas fa-paperclip mr-[5px]'></i>
                                            Anexo
                                        </TableHead>

                                        <TableHead>
                                            <i className='fas fa-user-edit mr-[5px]'></i>
                                            Atendente
                                        </TableHead>
                                    </TableHeader>


                                    <TableBody className=' font-normal'>
                                        {data.protocolo_retorno && data.protocolo_retorno.map(retorno => {
                                            return (
                                                <>
                                                    <TableRow key={retorno._id}>
                                                        <TableCell>{format(retorno.protocolo_retorno, 'dd/MM/yyyy')} - {retorno.protocolo_hretorno}</TableCell>
                                                        <TableCell>{retorno.protocolo_status}</TableCell>
                                                        <TableCell className='min-w-[200px] max-w-[350px]'>{retorno.protocolo_descricao}</TableCell>
                                                        <TableCell>{retorno.protocolo_anexo_retorno ? <a target='_blank' href={retorno.protocolo_anexo_retorno}>{retorno.protocolo_anexo_retorno}</a> : 'Nenhum arquivo anexado'}</TableCell>
                                                        <TableCell>{retorno.protocolo_atendente}</TableCell>
                                                    </TableRow>
                                                </>
                                            );
                                        })}
                                    </TableBody>

                                </Table>
                            </div>

                        </div>
                    ) : (
                        <AlertMessage message='Ocorreu um erro ao buscar pelos detalhes da solicitação. Tente novamente mais tarde.' />
                    )}
                </>

            )}
        </>


    )
}

export { DetalhesSolicitacaoComponent };